import { useMemo } from 'react';
import { COMBO_BOX_OPTIONS_3 } from '../combobox-popovers/all-filters-combobox-popover';
import LastUpdatedDateFiltersComboBoxPopover from '../combobox-popovers/last-updated-date-filters-combobox-popover';
import {
  LAST_UPDATED_DATE_FILTER_OPTIONS,
  type LastUpdatedDateFilterChipProps,
  type LastUpdatedDateFiltersState,
} from '../types';
import BaseDateFilterChip from './base-date-filter-chip';

const LastUpdatedDateFilterChip = (props: LastUpdatedDateFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  const selectedOption = useMemo(() => {
    return LAST_UPDATED_DATE_FILTER_OPTIONS.find(
      (option) => option.value === filtersState.selectedFilters,
    );
  }, [filtersState.selectedFilters]);

  const useBeforeAfterCopy = true;

  return (
    // TODO: fix the type
    <BaseDateFilterChip<LastUpdatedDateFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={LastUpdatedDateFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS_3.find(
          (option) => option.value === 'last_updated_date',
        )?.icon
      }
      filterName="Last updated date"
      filterQuantifier={{
        singular: selectedOption?.label || '',
        plural: selectedOption?.label || '',
      }}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      useBeforeAfterCopy={useBeforeAfterCopy}
    />
  );
};

export default LastUpdatedDateFilterChip;
